"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Enumerable.Range", "count", 1, "public", [{params: (context) => [Type.variablePattern("range_0")], guards: [], body: (context) => {
return Type.tuple([Type.atom("ok"), Elixir_Range["size/1"](context.vars.range_0)]);
}}]);

Interpreter.defineElixirFunction("Range", "size", 1, "public", [{params: (context) => [Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.variablePattern("last_1")], [Type.atom("step"), Type.variablePattern("step_2")]])], guards: [(context) => (Interpreter.toBoolean(Erlang[">/2"](context.vars.step_2, Type.integer(0n))) ? Erlang[">/2"](context.vars.first_0, context.vars.last_1) : Type.boolean(false))], body: (context) => {
return Type.integer(0n);
}}, {params: (context) => [Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.variablePattern("last_1")], [Type.atom("step"), Type.variablePattern("step_2")]])], guards: [(context) => (Interpreter.toBoolean(Erlang["</2"](context.vars.step_2, Type.integer(0n))) ? Erlang["</2"](context.vars.first_0, context.vars.last_1) : Type.boolean(false))], body: (context) => {
return Type.integer(0n);
}}, {params: (context) => [Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.variablePattern("last_1")], [Type.atom("step"), Type.variablePattern("step_2")]])], guards: [], body: (context) => {
return Erlang["+/2"](Erlang["abs/1"](Erlang["div/2"](Erlang["-/2"](context.vars.last_1, context.vars.first_0), context.vars.step_2)), Type.integer(1n));
}}, {params: (context) => [Type.matchPattern(Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Range")], [Type.atom("first"), Type.variablePattern("first_0")], [Type.atom("last"), Type.variablePattern("last_1")]]), Type.variablePattern("range_2"))], guards: [], body: (context) => {
Interpreter.matchOperator(Interpreter.case(Erlang["=</2"](context.vars.first_0, context.vars.last_1), [{match: Type.atom("false"), guards: [], body: (context) => {
return Type.integer(-1n);
}}, {match: Type.atom("true"), guards: [], body: (context) => {
return Type.integer(1n);
}}], context), Type.variablePattern("step_4"), context);
Interpreter.updateVarsToMatchedValues(context);
return Elixir_Range["size/1"](Elixir_Map["put/3"](context.vars.range_2, Type.atom("step"), context.vars.step_4));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));